import { createContext, useCallback, useContext, useMemo, useState } from "react";

// The nav sits in App.js, outside the participant page, so the Tour link needs
// a channel to the page that owns the dialog.
//
// The request is consumed by whoever handles it, rather than left standing.
// This provider outlives the page — it wraps the routes — so a request that
// stayed set would be seen again by the next Participant that mounts, and the
// tour would reopen on its own after navigating away and back. Clearing it on
// handling means only a fresh press of Tour opens anything.
const TourContext = createContext({
  tourRequested: false,
  openTour: () => {},
  consumeTourRequest: () => {},
});

export const useTour = () => useContext(TourContext);

export function TourProvider({ children }) {
  const [tourRequested, setTourRequested] = useState(false);

  const openTour = useCallback(() => setTourRequested(true), []);
  const consumeTourRequest = useCallback(() => setTourRequested(false), []);

  const value = useMemo(
    () => ({ tourRequested, openTour, consumeTourRequest }),
    [tourRequested, openTour, consumeTourRequest]
  );

  return <TourContext.Provider value={value}>{children}</TourContext.Provider>;
}

export default TourContext;
